<template>
	<div class="accordion-item" :class="{ error }">
		<div class="accordion-item__header" @click="onClick">
			<div class="accordion-item__header__icon">
				<IconClose v-if="open" />
				<IconOpen v-else />
			</div>
			<p class="accordion-item__header__label">{{ label }}</p>
		</div>
		<div class="accordion-item__content" :style="expanded">
			<div class="accordion-item__inner">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
import IconOpen from 'mdi-vue/Plus'
import IconClose from 'mdi-vue/Minus'

export default {
	name: 'AccordionItem',
	props: {
		label: String,
		error: Boolean,
		startOpen: Boolean
	},
	data() {
		return {
			open: false
		}
	},
	computed: {
		expanded() {
			return {
				height: this.open ? 'auto' : '0px'
			}
		}
	},
	methods: {
		onClick() {
			this.$emit('open', !this.open)
		}
	},
	created() {
		if (this.startOpen) this.open = true
	},
	components: {
		IconOpen,
		IconClose
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';

.accordion-item {
	&__header {
		@extend %flex-row;
		height: 3rem;
		background-color: $blue-98;
		cursor: pointer;

		&__label {
			@extend %field-label;
		}
		&__icon {
			height: 1.5rem;
			margin: 0 0.5rem;
			color: $blue-48;
		}
	}
	&__content {
		overflow: hidden;
	}
	&__inner {
		@include truncate-margin;
		padding: 1rem;
	}

	&.error &__header {
		background-color: $red-97;
		&__icon {
			color: $black;
		}
	}
}
</style>
